export const LIST_EDIT_VIEW_FORM_NAME = "EditListItemForm";
